import {
    Component,
    OnInit,
    OnChanges,
    Input,
    ViewChild,
    ElementRef,
    HostListener,
    IterableDiffers,
    KeyValueDiffers,
    ViewChildren,
    QueryList,
    DoCheck,
    AfterViewChecked
} from '@angular/core';
import { MessageService, SelectItem } from 'primeng/api';

import { StoryLinksDataSource } from './story-links-data-source';
import { LinksButtonModel } from '../../../Shared/components/Links/links-button.model';
import { storyLinksButton } from './story-links-button';

import { StoryContactsDataSource } from './story-contacts-data-source';
import { ContactsButtonModel } from '../../../Shared/components/Contacts/contacts-button.model';
import { storyContactsButton } from './story-contacts-button';

import { UnifiedStoryRequestModel } from '../../../../api/story/model/story-request.model';
import { StoryLink } from '../../../../api/story/model/story-link.model';

import { StorySubject } from '../../../../api/story/model/story-subject.model';
import { StoryContact } from '../../../../api/story/model/story-contact.model';
import { UnifiedStoryResponseModel } from '../../../../api/story/model/story-response.model';
import { Company } from '../../../../api/story/model/company.model';
import { Status } from '../../../../api/story/model/status.model';
import { FooterActionBarButtonModel } from '../../../../Common/Misc/models/footer-action-bar-button.model';
import { PublishMetadataModel } from '../../../../Common/Dialogs/models/publish-metadata.model';
import { StatusEnum } from '../../enums/status.enum';
import { AmplifyTypesEnum } from '../../../../api/amplify/enums/amplify-types.enum';
import { ErrorTypeEnum } from '../../../Shared/enums/error-type.enum';
import { ContactComponentText } from '../../../Shared/components/Contacts/contact-component-text';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import moment from 'moment-timezone';
import * as momentTimeZone_ from 'moment-timezone';
import { StoryComponentText } from './story-component-text';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NewsroomRightSideBarInterface } from '../NewsroomRightSideBar/newsroom-right-side-bar.interface';
import { Story } from '../../services/story.service';
import { deliverySchedulingTypesEnum } from '../../../../Common/Forms/enums/delivery-scheduling-types.enum';
import { TimeModel } from '../../../../Common/Forms/models/time.model';
import { timeFormatsEnum } from '../../../../Core/Users/enums/time-formats.enum';
import { TimeHelper } from '../../../../Common/Forms/helpers/time.helper';
import { ArticleViewModel } from '../../../../api/amplify/model/amplify-article-model';
import { ArticleContactModel } from '../../../../api/amplify/model/amplify-article-contact-model';
import { BodyContentsModel } from '../../../../api/story/model/body-content-model';
import { BodyContentTypesEnum } from '../../../../api/story/enums/body-content-types.enum';
import { canDeactivateGuardConstants } from '../../services/can-deactivate-guard.service';
import { PreferencesModel } from '../../../../Core/Users/models/preferences.model';
import { ContactsItemModel } from '../../../Shared/components/Contacts/contacts-data-item.model';
import { validateEmail } from '../../../../Common/Misc/helpers/formatting/email.helper';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { StoriesComponent } from '../stories/stories.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ConfirmDialogComponent } from '../../../../Common/Dialogs/components/ConfirmDialog/confirm-dialog.component';
import { ScrollPanelComponent } from '../../../../Common/Basic/components/ScrollPanel/scroll-panel.component';
import { PublishStoryDialogModel } from '../../../../Common/Dialogs/models/publish-story-dialog.model';
import { PublishStoryComponent } from '../../../../Common/Dialogs/components/PublishStory/publish-story.component';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { UsersService } from '../../../../Core/Users/services/users.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';

export const storyConstants: any = {
    author: 'Agility User',
    timeLimit: '3000',
    saveButtonText: 'Save as Draft',
    updateButtonText: 'Update',
    updateButtonTextOnStoryNameChange: 'UpdateOnStoryNameChange',
    publishButtonText: 'Publish',
    retractButtonText: 'Retract',
    cancelLabel: 'Cancel',
    retractlabel: 'Retract',
    confirmMessage: 'Are you sure you want to retract this story?',
    confirmation: 'Confirmation',
    updateStoryHeading: 'Story Updated',
    publishStoryHeading: 'Story Published',
    deleteStoryHeading: 'Story Deleted',
    retractConfirmStoryHeading: 'Retract?',
    retractStoryHeading: 'Story Retracted',
    createStoryHeading: 'Story Saved',
    updateMessage: ' has been successfully updated.',
    publishMessage: ' has been successfully published.',
    retractMessage: ' has been successfully retracted.',
    storyMessage: 'Story ',
    createMessage: ' has been successfully saved.',
    successSeverity: 'success',
    errorSeverity: 'error',
    acceptLabel: 'Yes',
    rejectLabel: 'No',
    publishedLabel: 'Published',
    companyLogoWidth: 200,
    companyLogoHeight: 80,
    storyImageWidth: 750,
    storyImageHeight: 140,
    logoImageType: 'logo',
    imageStreamBase64: /^data:[^;]+;base64,/,
    headlineMaxLength: 256,
    companyMaxLength: 64,
    sameUrlNavigationReload: 'reload',
    runGuardsAndResolvers: 'always',
    subjectDefault  : 'Not Set',
    errorHeading: 'Error',
    serverErrorMessage: 'An error has occurred. Please contact customer support.',
    maxImageSizeError: 'File size may not exceed (1MB)',
    sizeErrorMsgHeading: 'File Size Error',
    typeErrorMsgHeading: 'File Type Error',
    imageTypeError:  'Unsupported file type',
    imageErrorMessage:  'Unsupported image format',
    publishedDateText: 'Published Date',
    updatedDateText: 'Updated Date',
    minuteCompareLimit: 1,
    convertIntoMinute: 1000 * 60,
    distributionId: 'distributionId',
    id: 'id',
    publishStoryName: 'Story Name',
    publishReservedUrlTitle: 'Reserved URL',
    publishHeadlineTitle: 'Headline',
    publishCompanyNameTitle: 'Company Name'
};

@Component({
    selector: 'agpr-story',
    templateUrl: './story.component.html',
    styleUrls: ['./story.component.scss'],
    providers: [
        TimeHelper,
        StoryLinksDataSource,
        StoryContactsDataSource,
        UnifiedStoryRequestModel,
        UnifiedStoryResponseModel,
        Company,
        StoryContact,
        StoryLink,
        StorySubject,
        Status,
        Story
    ],
    standalone: false
})
export class StoryComponent implements OnInit, OnChanges, DoCheck, AfterViewChecked, NewsroomRightSideBarInterface {

    @Input() public storyId: number;
    @Input() public amplify: boolean = false;
    @Input() public storyType: AmplifyTypesEnum = AmplifyTypesEnum.Newsroom;
    @Input() public storyLocalization: StoryComponentText = new StoryComponentText();
    @ViewChild('storyNameInput') storyNameInput: ElementRef;
    @ViewChild('companyLogo') companyLogoElement: ElementRef;
    @ViewChild('about') aboutUsElement: ElementRef;
    @ViewChild('contacts') contactsElement: ElementRef;
    @ViewChild('links') linksElement: ElementRef;
    @ViewChildren('bodyComponent') bodyContentsElements: QueryList<ElementRef>;
    @ViewChild('scrollPanel', { static: true }) scrollPanel: ScrollPanelComponent;
    public bodyFormattedTextLimit: number = 65500;
    public localization = new ContactComponentText();
    public publishDisclaimers: string[];
    public showCompanyPlaceholder: boolean = true;
    public showCompanyInput: boolean = false;
    public aboutUsButtonDisabled: boolean = false;
    public aboutUsButton: boolean = false;
    public contactButtonDisabled: boolean = false;
    public contactButton: boolean = false;
    public linkButtonDisabled: boolean = false;
    public linkButton: boolean = false;
    public subjectDropDownDisabled: boolean = false;
    public showLogoPlaceholder: boolean = false;
    public showCompanyImageHtml: boolean = false;
    public showCompanyImageInput: boolean = true;
    public showLogoButton: boolean = false;
    public logoUrl: string;
    public logoWidth: number;
    public logoHeight: number;
    public showImageNormalMode: boolean = false;
    public metadata: PublishMetadataModel[] = [];
    public datelineDate: Date = null;

    public externalWebsiteURL: string;
    public id: number;
    public author: string = storyConstants.author;
    public companyId: number;
    public statusId: number;

    public minDate = new Date();
    public publishedTimeStamp: number;
    public publishDate: Date = null;
    public publishTime: TimeModel = null;
    public selectedSubject: number[] = [];
    public linkButtons: LinksButtonModel[];
    public contactButtons: ContactsButtonModel[];
    public subjectList: SelectItem[] = [];
    public btnSave: FooterActionBarButtonModel;
    public btnUpdate: FooterActionBarButtonModel;
    public btnPublish: FooterActionBarButtonModel;
    public btnRetract: FooterActionBarButtonModel;

    public timeLimit: string = storyConstants.timeLimit;
    public showPublishLater: boolean = false;
    public deliverySchedulingType: deliverySchedulingTypesEnum;
    public statusEnum = StatusEnum;
    public storyInfo: boolean = true;
    public scheduledPublishDate: Date = null;
    public isSubmitted: boolean = false;
    public isPublished: boolean = false;
    public contactsPublishErrors: boolean = false;
    public contactsDraftErrors: boolean = false;
    public isLoader: boolean = false;
    public showDialog: boolean = false;
    public reservedUrl: string = null;
    public logoPlaceholderName: string = 'Company Logo';
    public logoIcon: string = 'fa-regular fa-duotone fa-circle-star';
    public storyFormGroup: UntypedFormGroup = this.formBuilder.group(
        {
            name: new UntypedFormControl(''),
            body: new UntypedFormControl(''),
            aboutUs: new UntypedFormControl(''),
            headline: new UntypedFormControl(''),
            companyName: new UntypedFormControl(''),
            datelineLocation: new UntypedFormControl('')
        }
    );
    public publishedLabel: string = storyConstants.publishedLabel;
    public isRetracted: boolean = false;
    public subjectDefault: string = storyConstants.subjectDefault;
    public isLinkDirty: boolean = false;
    public isContactDirty: boolean = false;
    public isImageDirty: boolean = false;
    public isLogoDirty: boolean = false;
    public isSubjectListDirty: boolean = false;
    public isAboutUsDirty: boolean = false;
    public logoId: string;
    public storyCreatedBy: string;
    public storyModifiedBy: string;
    public dateText: string;
    public storyModifiedDate: string;
    public preferences: PreferencesModel;
    public isModelChanged: boolean = false;
    public maxImageContents: number = 10;
    public maxTextContents: number = 10;
    public remainingImageContents: number = 0;
    public remainingTextContents: number = 0;
    public bodyContents: BodyContentsModel[] = [];
    // eslint-disable-next-line @typescript-eslint/naming-convention
    public BodyContentTypes = BodyContentTypesEnum;
    private arrayDiffer: any;
    private keyValueDiffer: any;
    private scrollToElementName: string;
    private scrollToBodyContentIndex: number;
    public dateFormat: string;

    private storyModifiedByRequest: Subscription = null;

    constructor(
        public linksDataSource: StoryLinksDataSource,
        public contactsDataSource: StoryContactsDataSource,
        public storyRequestModel: UnifiedStoryRequestModel,
        public storyResponseModel: UnifiedStoryResponseModel,
        public companyModel: Company,
        public contactModel: StoryContact,
        public linkModel: StoryLink,
        public subjectModel: StorySubject,
        public statusModel: Status,
        public configService: ConfigService,
        private usersService: UsersService,
        private localizationService: LocalizationService,
        private timeHelper: TimeHelper,
        private formBuilder: UntypedFormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private currentUserStateService: CurrentUserStateService,
        iterableDiffers: IterableDiffers,
        keyValueDiffers: KeyValueDiffers,
        private storiesComponent: StoriesComponent,
        private messageService: MessageService,
        private coreDialogService: CoreDialogService
    ) {
        if (storiesComponent) {
            storiesComponent.routedComponent = this;
        }
        this.linkButtons = storyLinksButton;
        this.contactButtons = storyContactsButton;
        this.externalWebsiteURL = this.configService.getConfig().externalWebsiteURL;
        this.btnSave = new FooterActionBarButtonModel (storyConstants.saveButtonText, true, false);
        this.btnUpdate = new FooterActionBarButtonModel (storyConstants.updateButtonText, true, false);
        this.btnPublish = new FooterActionBarButtonModel (storyConstants.publishButtonText, true, false);
        this.btnRetract = new FooterActionBarButtonModel (storyConstants.retractButtonText, true, false);
        this.btnSave.click.subscribe(results => {
            this.onSaveClick(this.statusEnum.DRAFT);
        });
        this.btnUpdate.click.subscribe(results => {
            this.onSaveClick(this.statusEnum.DRAFT, storyConstants.updateButtonText);
        });
        this.btnPublish.click.subscribe(results => {
            this.onSaveClick(this.statusEnum.PUBLISHED, storyConstants.publishButtonText);
        });
        this.btnRetract.click.subscribe(results => {
            this.onSaveClick(this.statusEnum.RETRACTED, storyConstants.retractButtonText);
        });

        this.publishTime = new TimeModel();
        this.publishTime.timeZone = 'UTC';

        this.publishDisclaimers = [
            this.storyLocalization.publishDisclaimerMessage
        ];

        this.getPreferences();
        this.arrayDiffer = iterableDiffers.find([]).create(null);
        this.keyValueDiffer = keyValueDiffers.find({}).create();

        this.localization.contactName = 'Name';
        this.localization.contactPhone = 'Phone';
        this.localization.contactEmail = 'Email';
    }

    ngOnInit() {
        this.route.data.subscribe(data => {
            const snap = this.route.snapshot;
            const queryParams = snap.queryParams;

            this.storyId = +queryParams.storyId || +snap.params.id;
            this.amplify = queryParams.isAmplified === 'true';
            this.storyType = queryParams.storyType || AmplifyTypesEnum.Newsroom;

            this.isSubmitted = false;
            this.isPublished = false;
            this.subjectList = [];
            this.remainingImageContents = this.maxImageContents;
            this.remainingTextContents = this.maxTextContents;

            this.storiesComponent.getSubjectList().subscribe(subjects => {
                subjects.forEach(item => {
                    const subject = {
                        'label': item.name,
                        'value': item.id
                    };
                    this.subjectList.push(subject);
                });
            });
            this.resetStoryViewData();
            if (this.storyId > 0) {
                this.minDate = new Date();
                this.getStory(this.storyId, this.amplify, this.storyType);
            }
        });
    }

    ngOnChanges() {
        this.resetStoryViewData();
        this.resetPublishData();
        if (this.storyId > 0) {
            this.getStory(this.storyId, this.amplify, this.storyType);
        }
        this.isSubmitted = false;
        this.isPublished = false;
    }

    ngDoCheck() {
        // check for changes to the article body contents
        const changedBodyContents = this.arrayDiffer.diff(this.bodyContents);

        // check for changes to the article view model
        const changedViewState = this.keyValueDiffer.diff(this);

        // if there are too many changes, then we don't know what to scroll to
        let numberOfChanges = 0;

        // a bodyContent item may have been added
        if (changedBodyContents) {
            this.scrollToElementName = 'bodyContentsElements';
            changedBodyContents.forEachAddedItem((item) => {
                this.scrollToBodyContentIndex = item.currentIndex;
                numberOfChanges++;
            });
        }

        // a different optional component may have been added
        if (changedViewState) {
            changedViewState.forEachChangedItem((item) => {
                // Only care if the currentValue is true, because that means it was added to the screen
                if (item.currentValue === true) {
                    switch (item.key) {
                        case 'showLogoPlaceholder':
                            this.scrollToElementName = 'companyLogoElement';
                            numberOfChanges++;
                            break;
                        case 'contactButtonDisabled':
                            this.scrollToElementName = 'contactsElement';
                            numberOfChanges++;
                            break;
                        case 'aboutUsButtonDisabled':
                            this.scrollToElementName = 'aboutUsElement';
                            numberOfChanges++;
                            break;
                        case 'linkButtonDisabled':
                            this.scrollToElementName = 'linksElement';
                            numberOfChanges++;
                            break;
                    }
                }
            });
        }

        if (numberOfChanges !== 1) {
            // if there are too many changes, then we don't know what to scroll to
            this.scrollToBodyContentIndex = null;
            this.scrollToElementName = null;
        }
    }

    ngAfterViewChecked() {
        // if we found a new item
        if (this.scrollToElementName) {
            let element: ElementRef;
            // then find it's element on the screen now that it exists
            if (this.scrollToElementName === 'bodyContentsElements') {
                // it's one of the bodyContent elements
                element = this.bodyContentsElements.toArray()[this.scrollToBodyContentIndex];
            } else {
                // it's a different optional element
                element = this[this.scrollToElementName];
            }

            // clear the scrollTo so we don't try again if something goes wrong
            this.scrollToBodyContentIndex = null;
            this.scrollToElementName = null;

            // scroll to it if we can
            if (element) {
                this.scrollPanel.scrollIntoView(element);
            }
        }
    }

    get name() {
        return this.storyFormGroup.get('name');
    }

    get body() {
        return this.storyFormGroup.get('body');
    }

    get aboutUs() {
        return this.storyFormGroup.get('aboutUs');
    }

    get headline() {
        return this.storyFormGroup.get('headline');
    }

    get companyName() {
        return this.storyFormGroup.get('companyName');
    }

    get datelineLocation() {
        return this.storyFormGroup.get('datelineLocation');
    }

    @HostListener('window:beforeunload', ['$event'])
    pageUnload($event) {
        if (this.isFormDirty()) {
            $event.returnValue = canDeactivateGuardConstants.confirmMessageText;
        }
    }

    onDelete(): void {
        this.aboutUsButtonDisabled = false;
        this.aboutUsButton = false;

        if (this.aboutUs.value.trim() !== '' && !this.storyFormGroup.dirty) {
            this.isAboutUsDirty = true;
        }
        this.aboutUs.setValue('');
    }

    onContactControlDelete(): void {
        this.contactButtonDisabled = false;
        this.contactButton = false;
        this.checkForContactsError();
    }

    onLinkControlDelete(): void {
        this.linkButtonDisabled = false;
        this.linkButton = false;
    }

    checkHeadlineLength(event: any): void {
        if (event.target.textContent.length < storyConstants.headlineMaxLength) {
            this.headline.setValue(event.target.textContent);
        } else {
            event.preventDefault();
            return;
        }
    }

    checkCompanyLength(event: any): void {
        if (this.isRetracted) {
            return;
        }
        if (event.target.textContent.length < storyConstants.companyMaxLength) {
            this.companyName.setValue(event.target.textContent);
        } else {
            event.preventDefault();
            return;
        }
    }

    toggleCompany(): void {
        if (this.isRetracted) {
            return;
        }
        this.showCompanyPlaceholder = true;
        this.showCompanyInput = true;
    }

    setCompanyName(): void {
        this.showCompanyPlaceholder = true;
        this.showCompanyInput = false;
    }

    toggleAboutUs(): void {
        this.aboutUsButtonDisabled = true;
        this.aboutUsButton = true;
    }

    setSubjects(selectedItems): void {
        this.isSubjectListDirty = true;
        this.selectedSubject = selectedItems;
    }

    toggleContact(): void {
        this.contactButtonDisabled = true;
        this.showImageNormalMode = true;
        this.contactButton = true;
    }

    toggleLink(): void {
        this.linkButtonDisabled = true;
        this.linkButton = true;
    }

    toggleCompanyLogo() {
        this.showLogoPlaceholder = true;
        this.showCompanyImageHtml = true;
        this.showCompanyImageInput = false;
        this.showLogoButton = true;
        this.logoWidth = storyConstants.companyLogoWidth;
        this.logoHeight = storyConstants.companyLogoHeight;
    }
    public imageClick(type: string) {
        if (type === storyConstants.logoImageType) {
            this.showLogoPlaceholder = true;
            this.showLogoButton = true;
            this.showCompanyImageHtml = false;
            this.showCompanyImageInput = true;
            this.logoWidth = storyConstants.companyLogoWidth;
            this.logoHeight = storyConstants.companyLogoHeight;
            this.logoId = '';
        }
        if (type === 'image' && this.remainingImageContents > 0) {
            this.bodyContents.push(new BodyContentsModel(BodyContentTypesEnum.Image, ''));
            this.remainingImageContents--;
        }
    }

    public textClick(): void {
        if (this.remainingTextContents > 0) {
            this.bodyContents.push(new BodyContentsModel(BodyContentTypesEnum.Text, ''));
            this.remainingTextContents--;
        }
    }

    public deleteBodyContent(bodyContent: BodyContentsModel): void {
        const index = this.bodyContents.indexOf(bodyContent);
        this.bodyContents.splice(index, 1);
        if (
            (!this.isNullOrEmpty(bodyContent.bodyContent)
            || (!this.isNullOrEmpty(bodyContent.bodyContentId)))
            && !this.isFormDirty()
        ) {
            this.isModelChanged = true;
        }
        this.updateRemainingBodyContents();
    }

    public moveBodyContentUp(index: number): void {
        if (index < 1) {
            return;
        }
        const bodyContentA = this.bodyContents[index];
        const bodyContentB = this.bodyContents[index - 1];
        this.bodyContents[index] = bodyContentB;
        this.bodyContents[index - 1] = bodyContentA;
        this.isModelChanged = true;
    }
    public moveBodyContentDown(index: number): void {
        if (index >= this.bodyContents.length - 1) {
            return;
        }
        const bodyContentA = this.bodyContents[index];
        const bodyContentB = this.bodyContents[index + 1];
        this.bodyContents[index] = bodyContentB;
        this.bodyContents[index + 1] = bodyContentA;
        this.isModelChanged = true;
    }

    public updateRemainingBodyContents(): void {
        this.remainingImageContents = this.maxImageContents;
        this.remainingTextContents = this.maxTextContents;
        if (!this.bodyContents) {
            // if the article doesn't have bodyContents, then leave the values at max
            return;
        }
        for (const bodyContent of this.bodyContents) {
            if (bodyContent.bodyContentType === BodyContentTypesEnum.Text) {
                this.remainingTextContents--;
            } else if (bodyContent.bodyContentType === BodyContentTypesEnum.Image) {
                this.remainingImageContents--;
            }
        }
    }

    public showImageError(errorType: string) {
        if (errorType === ErrorTypeEnum.ImageFileType) {
            this.showMessage(storyConstants.typeErrorMsgHeading, storyConstants.imageTypeError, storyConstants.errorSeverity);
        }
        if (errorType === ErrorTypeEnum.ImagefileSize) {
            this.showMessage(storyConstants.sizeErrorMsgHeading, storyConstants.maxImageSizeError, storyConstants.errorSeverity);
        }
    }

    // Use to handle image
    public getBrowsedImage(imageData: string, bodyContent: BodyContentsModel): void {
        if (!this.isNullOrEmpty(imageData) || !this.isNullOrEmpty(bodyContent.bodyContent)) {
            this.isModelChanged = true;
            bodyContent.bodyContentId = null;
        }
        bodyContent.bodyContent = imageData;
    }

    public onModelChanged(): void {
        this.isModelChanged = true;
    }

    // TODO this will use to handle company logo image
    public getBrowsedLogo(logoUrl: string): void {
        this.logoUrl = logoUrl;
    }

    public markFormPristine(form: UntypedFormGroup): void {
        Object.keys(form.controls).forEach(control => {
            form.controls[control].markAsPristine();
        });
        this.isLinkDirty = false;
        this.isContactDirty = false;
        this.isImageDirty = false;
        this.isLogoDirty = false;
        this.isSubjectListDirty = false;
        this.isAboutUsDirty = false;
        this.isModelChanged = false;
    }

    public emitSavedStoryStatus(storyId: number): void {
        this.storiesComponent?.getSavedStoryStatus(storyId);
        this.markFormPristine(this.storyFormGroup);
    }

    public checkForContactsError(): boolean {
        const contacts = this.contactsDataSource.dataSource;
        const validContact = contacts.find((contact) => {
            if (!contact.name || contact.name.trim().length < 1) {
                return false;
            }
            if ((!contact.phoneNumber || contact.phoneNumber.trim().length < 1)
                && (!contact.emailAddress || contact.emailAddress.trim().length < 1)) {
                return false;
            }
            return true;
        });
        this.contactsPublishErrors = !validContact;

        return this.contactsPublishErrors;
    }

    public checkForContactsEmailError(): void {
        const contacts = this.contactsDataSource.dataSource;
        let invalidEmail: boolean = false;
        contacts.forEach((contact) => {
            if (contact.emailAddress) {
                if (!validateEmail(contact.emailAddress)) {
                    invalidEmail = true;
                }
            }
        });
        this.contactsDraftErrors = invalidEmail;
    }

    private isFormValid(buttonStatus: string): boolean {
        let formFlag: boolean = true;

        if (this.body && this.body.value.length > this.bodyFormattedTextLimit) {
            formFlag = false;
        }

        if ((buttonStatus == null || buttonStatus === storyConstants.saveButtonText)) {
            // Save button only needs to verify that the name is valid and that there isn't an invalid email
            this.isSubmitted = true;
            this.checkForContactsEmailError();
            if (!this.name || this.name.value.trim() === '' || this.contactsDraftErrors) {
                formFlag = false;
                this.showMessage(this.storyLocalization.saveFailedHeading, this.storyLocalization.saveFailedMessage, storyConstants.errorSeverity);
            }
        } else if ((buttonStatus === storyConstants.publishButtonText || buttonStatus === storyConstants.updateButtonText)) {
            this.isPublished = true;

            // Publish and update have to verify all of the required fields
            if (
                (!this.name || this.name.value.trim() === '')
                || (!this.companyName || this.companyName.value.trim() === '')
                || (!this.headline || this.headline.value.trim() === '')
                || (!this.datelineLocation || this.datelineLocation.value.trim() === '')
                || (!this.datelineDate)
                || (!this.body || this.body.value.trim() === '')
            ) {
                formFlag = false;
            }

            // Check contacts error separately so it triggers the appropriate flags
            if (this.checkForContactsError()) {
                formFlag = false;
            }

            // delivery time should not be verified for update
            // since you should be able to update an already published story without changing the date
            if (
                buttonStatus === storyConstants.publishButtonText
                && this.deliverySchedulingType === deliverySchedulingTypesEnum.future
                && this.publishDate < this.minDate
            ) {
                formFlag = false;
            }
        }
        // Retract doesn't need to check anything else

        if (!formFlag) {
            this.storyNameInput.nativeElement.focus();
        }

        return formFlag;
    }

    public isFormDirty(): boolean {
        let isFormDirty = (
            this.isLinkDirty
            || this.isContactDirty
            || this.isImageDirty
            || this.isLogoDirty
            || this.isSubjectListDirty
            || this.isAboutUsDirty
        );

        if (!isFormDirty && this.storyFormGroup) {
            isFormDirty = this.storyFormGroup.dirty;
        }

        return isFormDirty || this.isModelChanged;
    }

    public rightGroupButton(storyId: number = 0, status: StatusEnum = StatusEnum.DRAFT, publishedDate?: number): FooterActionBarButtonModel[] {
        const footerActionleftbutton: FooterActionBarButtonModel[] = [];

        if ((storyId === 0)) {
            footerActionleftbutton.push(this.btnSave);
        } else if (status === StatusEnum.DRAFT && this.isFormDirty()) {
            footerActionleftbutton.push(this.btnSave);
        } else if (status === StatusEnum.DRAFT && !this.isFormDirty()) {
            footerActionleftbutton.push(this.btnPublish);
        } else if ((status === StatusEnum.PUBLISHED || status === StatusEnum.SCHEDULED) && this.isFormDirty()) {
            footerActionleftbutton.push(this.btnUpdate);
        } else if (status === StatusEnum.PUBLISHED || status === StatusEnum.SCHEDULED) {
            footerActionleftbutton.push(this.btnRetract);
        }
        return footerActionleftbutton;
    }

    public openPublishDialog(): void {
        const io: PublishStoryDialogModel = {
            inputs: {
                id: 'Newsroom.story.publish',
                headerIcon: 'agpr-i-line-bullhorn',
                header: 'Publish',
                metadata: this.metadata,
                guideline: this.storyLocalization.newroomGuideline,
                storyInfo: this.storyInfo,
                disclaimers: this.publishDisclaimers
            },
            outputs: {
                dialogClose: (confirmed: boolean) => {
                    this.doPublish(confirmed);
                }
            }
        };
        this.coreDialogService.open(PublishStoryComponent, io);
    }

    public onSaveClick(status: StatusEnum, buttonStatus: string = null) {
        if (!this.isFormValid(buttonStatus)) {
            if (buttonStatus === storyConstants.updateButtonText || buttonStatus === storyConstants.publishButtonText) {
                this.showMessage(
                    this.storyLocalization.publishFailedHeading,
                    this.storyLocalization.publishFailedMessage.replace('[[name]]', this.name.value),
                    storyConstants.errorSeverity
                );
            }
            return;
        }

        this.setStatus(status);

        if (buttonStatus === storyConstants.updateButtonText || buttonStatus === storyConstants.publishButtonText) {
            if (this.id > 0) {
                this.setStoryUpdateData(buttonStatus);
                this.metadata = [
                    new PublishMetadataModel(storyConstants.publishStoryName, this.name.value),
                    new PublishMetadataModel(storyConstants.publishHeadlineTitle, this.headline.value),
                    new PublishMetadataModel(storyConstants.publishCompanyNameTitle, this.companyModel.name),
                    new PublishMetadataModel(storyConstants.publishReservedUrlTitle, this.reservedUrl)
                ];
                this.openPublishDialog();
                this.storyInfo = true;
            }
        } else if (buttonStatus === storyConstants.retractButtonText) {
            this.coreDialogService.open(
                ConfirmDialogComponent,
                {
                    inputs: {
                        heading: storyConstants.retractConfirmStoryHeading,
                        message: storyConstants.confirmMessage,
                        okLabel: storyConstants.retractlabel,
                        cancelLabel: storyConstants.cancelLabel
                    },
                    outputs: {
                        dialogClose: (confirmed: boolean) => {
                            if (confirmed) {
                                if (this.id > 0) {
                                    this.isLoader = true;
                                    this.setStoryUpdateData(buttonStatus);
                                    this.storiesComponent.updateStory(
                                        this.id,
                                        <UnifiedStoryRequestModel>this.storyRequestModel
                                    ).subscribe({
                                        next: (data) => {
                                            this.isLoader = false;
                                            this.storyResponseModel = data;
                                            const message = storyConstants.storyMessage + this.storyResponseModel.name + storyConstants.retractMessage;
                                            this.showMessage(storyConstants.retractStoryHeading, message, storyConstants.successSeverity);
                                            this.emitSavedStoryStatus(data.id);
                                            this.resetPublishData();
                                            this.setStoryViewData();
                                        },
                                        error: (error) => {
                                            this.isLoader = false;
                                            this.handleError(error);
                                        }
                                    });
                                }
                            }
                        }
                    }
                }
            );
        } else {
            if (this.id > 0) {
                this.isLoader = true;
                this.setStoryUpdateData();
                this.storiesComponent.updateStory(
                    this.id,
                    <UnifiedStoryRequestModel>this.storyRequestModel
                ).subscribe({
                    next: (data) => {
                        this.storyResponseModel = data;
                        const message = storyConstants.storyMessage + this.storyResponseModel.name + storyConstants.createMessage;
                        this.showMessage(storyConstants.updateStoryHeading, message, storyConstants.successSeverity);
                        this.emitSavedStoryStatus(data.id);
                        this.isLoader = false;
                        this.resetPublishData();
                        this.setStoryViewData();
                    },
                    error: (error) => {
                        this.isLoader = false;
                        this.handleError(error);
                    }
                });
            } else {
                this.isLoader = true;
                this.setStoryCreateData();
                this.storiesComponent.createStory(
                    <UnifiedStoryRequestModel>this.storyRequestModel
                ).subscribe({
                    next: (data) => {
                        this.isLoader = false;
                        this.amplify = false;
                        this.storyResponseModel = data;
                        const message = storyConstants.storyMessage + this.storyResponseModel.name + storyConstants.createMessage;
                        this.showMessage(storyConstants.createStoryHeading, message, storyConstants.successSeverity);
                        this.emitSavedStoryStatus(data.id);
                    },
                    error: (error) => {
                        this.isLoader = false;
                        this.handleError(error);
                    }
                });
            }
        }
    }

    doPublish(event: boolean): void {
        if (event === true) {
            this.isLoader = true;
            this.storiesComponent.updateStory(
                this.id,
                <UnifiedStoryRequestModel>this.storyRequestModel
            ).subscribe({
                next: (data) => {
                    this.storyResponseModel = data;
                    const message = storyConstants.storyMessage + this.storyResponseModel.name + storyConstants.publishMessage;
                    this.showMessage(storyConstants.publishStoryHeading, message, storyConstants.successSeverity);
                    this.emitSavedStoryStatus(data.id);
                    this.isLoader = false;
                    this.resetPublishData();
                    this.setStoryViewData();
                },
                error: (error) => {
                    this.isLoader = false;
                    this.handleError(error);
                }
            });
        }
    }

    public getStory(id: number, amplify: boolean = false, storyType: AmplifyTypesEnum = AmplifyTypesEnum.Newsroom) {
        this.isLoader = true;
        if (amplify === true && storyType === AmplifyTypesEnum.Newswire) {
            this.storiesComponent.getArticleDetailFromNewswire(id).subscribe({
                next: (data) => {
                    this.storyResponseModel = this.articleToStoryResponse(data);
                    this.setStoryAmplifyData();
                    this.isLoader = false;
                },
                error: (error) => {
                    this.isLoader = false;
                    this.handleError(error);
                }
            });
        } else {
            this.storiesComponent.getStory(
                id
            ).subscribe({
                next: (data) => {
                    this.storyResponseModel = data;
                    this.setStoryCreatedBy();
                    this.setStoryModifiedBy();
                    if (amplify === true) {
                        this.setStoryAmplifyData();
                    } else {
                        this.resetPublishData();
                        this.setStoryViewData();
                    }

                    this.isLoader = false;
                },
                error: (error) => {
                    this.isLoader = false;
                    this.handleError(error);
                }
            });
        }
    }

    private imagesToBodyContents(images: string[]): void {
        this.bodyContents = [];
        if (images && images.length > 0) {
            images.forEach((imageUrl, index) => {
                this.storiesComponent.getImage(imageUrl)
                    .subscribe({
                        next: (imageData) => {
                            this.createImageFromBlob(
                                imageData,
                                image => {
                                    const imageRawData = image.toString().replace(storyConstants.imageStreamBase64, '');
                                    this.bodyContents.push(new BodyContentsModel(BodyContentTypesEnum.Image, imageRawData, null, null, index));
                                    this.bodyContents.sort(this.sortBodyContents);
                                    this.remainingImageContents--;
                                }
                            );
                        },
                        error: (error) => this.handleError(error)
                    });
            });
        }
    }

    private createImageFromBlob(
        imageBlob: Blob,
        callback
    ): void {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            callback(reader.result);
        }, false);

        if (imageBlob) {
            reader.readAsDataURL(imageBlob);
        }
    }

    /**
     *  Convert Newswire article to story
     */
    private articleToStoryResponse(
        article: ArticleViewModel
    ): UnifiedStoryResponseModel {
        const storyResponse: UnifiedStoryResponseModel = new UnifiedStoryResponseModel();
        storyResponse.name = article.articleName;
        storyResponse.aboutUs = article.aboutUs;
        if (article.bodyContents) {
            article.bodyContents = this.bodyContentsWithoutVideos(article.bodyContents);
            article.bodyContents.sort(this.sortBodyContents);
        }
        storyResponse.body = article.body;
        storyResponse.bodyContents = article.bodyContents;
        storyResponse.company = { name: article.companyName, imageData: article.companyLogo };
        storyResponse.headline = article.headline;
        storyResponse.id = article.articleId;
        storyResponse.links = [];
        storyResponse.datelineDate = article.datelineDate;
        storyResponse.datelineLocation = article.datelineLocation;
        article.links.forEach(link => {
            storyResponse.links.push({ id: 0, webAddress: link });
        });
        storyResponse.contacts = [];
        article.contacts.forEach(contact => {
            storyResponse.contacts.push(this.articleContactToStoryContact(contact));
        });
        return storyResponse;
    }

    /**
     *  Remove videos from articles as Newsroom does not support videos in story
     */
    private bodyContentsWithoutVideos(bodyContents: BodyContentsModel[]): BodyContentsModel[]  {
        const contents: BodyContentsModel[] = [];
        bodyContents.forEach(bodyContent => {
            if (bodyContent.bodyContentType.toUpperCase() !== BodyContentTypesEnum.Video) {
                bodyContent.bodyContentType = bodyContent.bodyContentType.toUpperCase();
                contents.push(bodyContent);
            }
        });

        return contents;
    }

    /**
     *  Convert articlet contact to story contact
     */
    private articleContactToStoryContact(
        articleContact: ArticleContactModel
    ): StoryContact {
        const storyContact: StoryContact = new StoryContact();
        storyContact.address = articleContact.contactAddress;
        storyContact.name = articleContact.contactName;
        storyContact.emailAddress = articleContact.emailAddress;
        storyContact.mobileNumber = articleContact.mobileNumber;
        storyContact.phoneNumber = articleContact.phoneNumber;
        storyContact.title = articleContact.title;
        storyContact.webAddress = articleContact.webAddress;
        storyContact.imageData = articleContact.imageData;
        storyContact.id = articleContact.articleContactId;
        return storyContact;
    }

    /**
    * Sort Body Contents
    */
    private sortBodyContents(
        a: BodyContentsModel,
        b: BodyContentsModel
    ): number {
        return a.orderId - b.orderId;
    }

    public setStoryAmplifyData(): void {
        const hasPublishDate: boolean = !!this.storyResponseModel.publishedDate;

        this.storyResponseModel.id = 0;
        this.id = 0;

        if (!this.isNullOrEmpty(this.storyResponseModel.name)) {
            this.name.setValue(this.storyResponseModel.name.trim());
        }

        if (!this.isNullOrEmpty(this.storyResponseModel.headline)) {
            this.headline.setValue(this.storyResponseModel.headline.trim());
        }

        if (this.storyResponseModel.datelineDate) {
            this.datelineDate = new Date(this.storyResponseModel.datelineDate);
        }

        if (!this.isNullOrEmpty(this.storyResponseModel.datelineLocation)) {
            this.datelineLocation.setValue(this.storyResponseModel.datelineLocation.trim());
        }

        if (!this.isNullOrEmpty(this.storyResponseModel.body)) {
            this.body.setValue(this.storyResponseModel.body.trim());
        }

        this.bodyContents = [];
        if (
            this.storyResponseModel.bodyContents
            && this.storyResponseModel.bodyContents.length > 0
        ) {
            this.storyResponseModel.bodyContents.forEach(bodyContent => {
                this.bodyContents.push(
                    new BodyContentsModel(bodyContent.bodyContentType, bodyContent.bodyContent, null, bodyContent.bodyContentId)
                );
            });
            this.updateRemainingBodyContents();
        }

        if (
            this.storyResponseModel.company &&
            (!this.isNullOrEmpty(this.storyResponseModel.company.imageId) || !this.isNullOrEmpty(this.storyResponseModel.company.imageData))
        ) {
            this.logoId = this.storyResponseModel.company.imageId;
            this.logoUrl = this.storyResponseModel.company.imageData;
            this.toggleCompanyLogo();
        } else {
            this.logoId = null;
            this.logoUrl = null;
        }

        if (!this.isNullOrEmpty(this.storyResponseModel.author)) {
            this.author = this.storyResponseModel.author;
        } else {
            this.author = storyConstants.author;
        }

        if (this.storyResponseModel.aboutUs && !this.isNullOrEmpty(this.storyResponseModel.aboutUs)) {
            this.aboutUs.setValue(this.storyResponseModel.aboutUs);
            this.toggleAboutUs();
        }

        if (hasPublishDate) {
            const newPublishDate = new Date(this.storyResponseModel.publishedDate);
            if (newPublishDate >= new Date() && this.storyResponseModel.statusId !== StatusEnum.PUBLISHED) {
                const timeZone = this.storyResponseModel.timeZone ? this.storyResponseModel.timeZone : this.preferences.timeZone;
                this.publishTime = this.timeHelper.getTimeFromDate(newPublishDate, timeZone, timeFormatsEnum.twelveHour);
                this.publishDate = newPublishDate;
                this.deliverySchedulingType = deliverySchedulingTypesEnum.future;
            }
        } else {
            this.storyResponseModel.publishedDate = null;
        }

        if (this.storyResponseModel.company != null) {
            this.storyResponseModel.company.id = 0;
            this.companyId = 0;
            this.companyName.setValue(this.storyResponseModel.company.name.trim());
        }

        if (this.storyResponseModel.contacts != null && this.storyResponseModel.contacts.length > 0) {
            this.contactsDataSource.dataSource = [];
            this.storyResponseModel.contacts.forEach(contactItem => {
                contactItem.id = 0;
                this.contactsDataSource.dataSource.push(contactItem);
            });
            this.toggleContact();
        }

        if (this.storyResponseModel.links != null && this.storyResponseModel.links.length > 0) {
            this.linksDataSource.dataSource = [];
            this.storyResponseModel.links.forEach(linkItem => {
                linkItem.id = 0;
                this.linksDataSource.dataSource.push(linkItem);
            });
            this.toggleLink();
        }

        if (this.storyResponseModel.subjects != null && this.storyResponseModel.subjects.length > 0) {
            for (const subject of this.storyResponseModel.subjects) {
                this.selectedSubject.push(subject.id);
            }
        }

        this.statusModel.id = StatusEnum.DRAFT;
        this.storyResponseModel.status = this.statusModel;

    }

    private setStoryCreateData(): void {
        const publishLater: boolean = this.deliverySchedulingType === deliverySchedulingTypesEnum.future;
        const hasPublishDate: boolean = this.hasPublishDate();
        this.storyRequestModel = new UnifiedStoryRequestModel;

        if (!this.isNullOrEmpty(this.name.value)) {
            this.storyRequestModel.name = this.name.value.trim();
        }

        if (!this.isNullOrEmpty(this.headline.value)) {
            this.storyRequestModel.headline = this.headline.value.trim();
        }

        if (!this.isNullOrEmpty(this.body.value)) {
            this.storyRequestModel.body = this.body.value.trim();
        }

        if (this.datelineDate) {
            this.storyRequestModel.datelineDate = +(moment(this.datelineDate).tz('UTC', true).toDate());
        }

        if (!this.isNullOrEmpty(this.datelineLocation.value)) {
            this.storyRequestModel.datelineLocation = (this.datelineLocation.value.trim());
        }

        this.setBodyContentsToStoryRequestModel();
        this.storyRequestModel.author = this.author;

        if (!this.isNullOrEmpty(this.aboutUs.value)) {
            this.storyRequestModel.aboutUs = this.aboutUs.value;
        }

        this.storyRequestModel.status = this.statusModel;

        if (!this.isNullOrEmpty(this.companyName.value)) {
            this.companyModel.name = this.companyName.value.trim();
            this.storyRequestModel.company = this.companyModel;
        }

        if (this.contactsDataSource.dataSource.length > 0) {
            const storyContact: StoryContact[] = [];
            this.contactsDataSource.dataSource.forEach(item => {
                if (
                    (item.name !== undefined  && item.name !== '')
                    || (item.title !== undefined  && item.title !== '')
                    || (item.emailAddress !== undefined  && item.emailAddress !== '')
                    || (item.address !== undefined  && item.address !== '')
                    || (item.phoneNumber !== undefined  && item.phoneNumber !== '')
                    || (item.mobileNumber !== undefined  && item.mobileNumber !== '')
                    || (item.webAddress !== undefined  && item.webAddress !== '')
                    || (item.imageData !== undefined  && item.imageData !== '')
                    || (item.imageId !== undefined  && item.imageId !== '')
                ) {
                    if (item.imageData === undefined) {
                        item.imageData = null;
                    }
                    if (item.imageId === undefined) {
                        item.imageId = null;
                    }
                    if (item.imageData !== undefined && item.imageData != null && item.imageData !== '') {
                        item.imageId = null;
                    }
                    storyContact.push(item);
                }
            });
            if (storyContact.length > 0) {
                this.storyRequestModel.contacts = storyContact;
            }
        }

        if (this.linksDataSource.dataSource.length > 0) {
            const storyLinks: StoryLink[] = [];
            this.linksDataSource.dataSource.forEach(linkItem => {
                if (linkItem.webAddress && linkItem.webAddress.trim() !== '') {
                    storyLinks.push(linkItem);
                }
            });
            if (storyLinks.length > 0) {
                this.storyRequestModel.links = storyLinks;
            }
        }

        if (this.selectedSubject.length > 0) {
            const storySubjects: StorySubject[] = [];
            this.selectedSubject.forEach(item => {
                const subjectList = new StorySubject;
                subjectList.id = item;
                storySubjects.push(subjectList);
            });
            this.storyRequestModel.subjects = storySubjects;
        }

        if (this.logoUrl || this.logoId) {
            if (!this.storyRequestModel.company) {
                this.storyRequestModel.company = new Company();
                this.storyRequestModel.company.name = '';
            }

            if (this.logoUrl &&
                !this.isNullOrEmpty(this.logoUrl)) {
                this.storyRequestModel.company.imageId = null;
                this.storyRequestModel.company.imageData = this.logoUrl;
            } else {
                this.storyRequestModel.company.imageId = this.isNullOrEmpty(this.logoId) ? null : this.logoId;
                this.storyRequestModel.company.imageData = null;
            }
        }

        if (hasPublishDate && publishLater) {
            this.storyRequestModel.publishedDate = this.getPublishTimestamp();
            this.storyRequestModel.timeZone = this.publishTime.timeZone;
        }
    }

    /**
     * Sets storyCreatedBy to the first and last name
     * of the user who created the story
    */
    private setStoryCreatedBy(): void {
        this.currentUserStateService.getAccountUsers()
            .pipe(
                filter(x => !!x),
                take(1)
            )
            .subscribe(users => {
                const user = users.find(accountUser => accountUser.id === this.storyResponseModel.createdUserId);
                if (!user) {
                    this.storyCreatedBy = this.localizationService.transform('Common.unknownUser');
                } else {
                    this.storyCreatedBy = `${user.firstName} ${user.lastName}`;
                }
            });
    }

    /**
     * Sets storyModifiedBy to the first and last name
     * of the user who modified the story
    */
    private setStoryModifiedBy(): void {
        // If copying from an existing story, there is no modifiedUserId, we can use the createdUserId since it has never been saved before
        const userId = this.storyResponseModel.modifiedUserId || this.storyResponseModel.createdUserId;
        this.currentUserStateService.getAccountUsers()
            .pipe(
                filter(x => !!x),
                take(1)
            )
            .subscribe(users => {
                const user = users.find(accountUser => accountUser.id === userId);
                if (!user) {
                    this.storyModifiedBy = this.localizationService.transform('Common.unknownUser');
                } else {
                    this.storyModifiedBy = `${user.firstName} ${user.lastName}`;
                }
            });
    }

    /**
     * Set body contents to the api request
     */
    private setBodyContentsToStoryRequestModel(): void {
        this.storyRequestModel.bodyContents = [];
        if (this.bodyContents && this.bodyContents.length > 0) {
            this.bodyContents.forEach(bodyContent => {
                if (bodyContent && (!this.isNullOrEmpty(bodyContent.bodyContent) || !this.isNullOrEmpty(bodyContent.bodyContentId))) {
                    this.storyRequestModel.bodyContents.push(
                        new BodyContentsModel(
                            bodyContent.bodyContentType,
                            bodyContent.bodyContent,
                            bodyContent.id,
                            bodyContent.bodyContentId
                        )
                    );
                }
            });
        }
    }

    private setStoryUpdateData(buttonStatus: string = null): void {
        const publishLater: boolean = this.deliverySchedulingType === deliverySchedulingTypesEnum.future;
        const hasPublishDate: boolean = this.hasPublishDate();

        this.storyRequestModel = new UnifiedStoryRequestModel;

        if (!this.isNullOrEmpty(this.name.value)) {
            this.storyRequestModel.name = this.name.value.trim();
        }

        if (!this.isNullOrEmpty(this.headline.value)) {
            this.storyRequestModel.headline = this.headline.value.trim();
        }

        if (!this.isNullOrEmpty(this.body.value)) {
            this.storyRequestModel.body = this.body.value.trim();
        }
        if (this.datelineDate) {
            this.storyRequestModel.datelineDate = +(moment(this.datelineDate).tz('UTC', true).toDate());
        }
        if (!this.isNullOrEmpty(this.datelineLocation.value)) {
            this.storyRequestModel.datelineLocation = this.datelineLocation.value.trim();
        }

        this.setBodyContentsToStoryRequestModel();
        this.storyRequestModel.author = storyConstants.author;

        if (!this.isNullOrEmpty(this.aboutUs.value)) {
            this.storyRequestModel.aboutUs = this.aboutUs.value;
        }

        if (
            (buttonStatus === storyConstants.publishButtonText || buttonStatus === storyConstants.updateButtonText)
            && hasPublishDate
            && publishLater
        ) {
            this.statusModel.id = this.statusEnum.SCHEDULED;
        } else if (buttonStatus === storyConstants.publishButtonText) {
            this.storyRequestModel.publishedDate = this.getTimestamp(new Date());
            this.statusModel.id = StatusEnum.PUBLISHED;
        } else if (buttonStatus === storyConstants.retractButtonText) {
            this.statusModel.id = StatusEnum.RETRACTED;
        } else if (buttonStatus === storyConstants.updateButtonText &&
            this.statusId === StatusEnum.PUBLISHED) {
            this.statusModel.id = StatusEnum.PUBLISHED;
            this.storyRequestModel.publishedDate = this.publishedTimeStamp;
        } else if (buttonStatus === storyConstants.updateButtonText) {
            this.statusModel.id = StatusEnum.PUBLISHED;
            this.storyRequestModel.publishedDate = this.getPublishTimestamp();
        } else {
            this.statusModel.id = StatusEnum.DRAFT;
        }

        if (hasPublishDate && publishLater) {
            this.storyRequestModel.publishedDate = this.getPublishTimestamp();
            this.storyRequestModel.timeZone = this.publishTime.timeZone;
        }

        this.storyRequestModel.status = this.statusModel;


        if (!this.isNullOrEmpty(this.companyName.value) || (this.statusModel.id === StatusEnum.DRAFT)) {
            this.companyModel.id = this.companyId;
            this.companyModel.name = this.companyName.value.trim();
            this.storyRequestModel.company = this.companyModel;
        }

        if (this.linksDataSource.dataSource != null && this.linksDataSource.dataSource.length > 0) {
            const storyLinks: StoryLink[] = [];
            this.linksDataSource.dataSource.forEach(linkItem => {
                if (linkItem.webAddress && linkItem.webAddress.trim() !== '') {
                    storyLinks.push(linkItem);
                }
            });
            if (storyLinks.length > 0) {
                this.storyRequestModel.links = storyLinks;
            }
        }

        if (this.selectedSubject.length > 0) {
            const storySubjects: StorySubject[] = [];
            this.selectedSubject.forEach(item => {
                this.subjectList.forEach(subject => {
                    if (subject.value === item) {
                        const subjectList = new StorySubject;
                        subjectList.id = item;
                        subjectList.name = subject.label;
                        storySubjects.push(subjectList);
                    }
                });
            });
            this.storyRequestModel.subjects = storySubjects;
        }

        if (this.contactsDataSource.dataSource.length > 0) {
            const storyContact: StoryContact[] = [];
            this.contactsDataSource.dataSource.forEach(item => {
                if (
                    (item.name !== undefined  && item.name !== '')
                    || (item.title !== undefined  && item.title !== '')
                    || (item.emailAddress !== undefined  && item.emailAddress !== '')
                    || (item.address !== undefined  && item.address !== '')
                    || (item.phoneNumber !== undefined  && item.phoneNumber !== '')
                    || (item.mobileNumber !== undefined  && item.mobileNumber !== '')
                    || (item.webAddress !== undefined  && item.webAddress !== '')
                    || (item.imageData !== undefined  && item.imageData !== '')
                    || (item.imageId !== undefined  && item.imageId !== '')
                ) {
                    if (item.imageData === undefined) {
                        item.imageData = null;
                    }
                    if (item.imageId === undefined) {
                        item.imageId = null;
                    }
                    if (
                        item.imageData !== undefined
                        && item.imageData != null
                        && item.imageData !== ''
                    ) {
                        item.imageId = null;
                    }
                    storyContact.push(item);
                }
            });
            if (storyContact.length > 0) {
                this.storyRequestModel.contacts = storyContact;
            }
        }

        if (this.isLogoDirty) {
            this.storyRequestModel.company.imageId = null;
            this.storyRequestModel.company.imageData = this.isNullOrEmpty(this.logoUrl) ? null : this.logoUrl;
        } else {
            this.storyRequestModel.company.imageId = this.isNullOrEmpty(this.logoId) ? null : this.logoId;
            this.storyRequestModel.company.imageData = null;
        }

    }

    private isNullOrEmpty(value: string): boolean {
        return (value == null || value.trim() === '');
    }

    public setStoryViewData(): void {
        const hasPublishDate: boolean = !!this.storyResponseModel.publishedDate;

        if (this.storyResponseModel.id > 0) {
            this.id = this.storyResponseModel.id;
        }

        if (!this.isNullOrEmpty(this.storyResponseModel.name)) {
            this.name.setValue(this.storyResponseModel.name.trim());
        }

        if (!this.isNullOrEmpty(this.storyResponseModel.headline)) {
            this.headline.setValue(this.storyResponseModel.headline.trim());
        }

        if (this.storyResponseModel.datelineDate) {
            this.datelineDate = moment.utc(this.storyResponseModel.datelineDate).local(true).toDate();
        }

        if (!this.isNullOrEmpty(this.storyResponseModel.datelineLocation)) {
            this.datelineLocation.setValue(this.storyResponseModel.datelineLocation.trim());
        }

        if (!this.isNullOrEmpty(this.storyResponseModel.body)) {
            this.body.setValue(this.storyResponseModel.body.trim());
        }

        if (!this.isNullOrEmpty(this.storyResponseModel.author)) {
            this.author = this.storyResponseModel.author;
        }

        if (!this.isNullOrEmpty(this.storyResponseModel.aboutUs)) {
            this.aboutUs.setValue(this.storyResponseModel.aboutUs);
            this.toggleAboutUs();
        }

        if (hasPublishDate) {
            this.setPublishDateAndTime();
        }

        this.setStoryModifiedBy();

        if (this.storyResponseModel.company != null) {
            if (this.storyResponseModel.company.id != null && this.storyResponseModel.company.id > 0) {
                this.companyId = this.storyResponseModel.company.id;
            }

            if (!this.isNullOrEmpty(this.storyResponseModel.company.name)) {
                this.companyName.setValue(this.storyResponseModel.company.name.trim());
            }

            if (!this.isNullOrEmpty(this.storyResponseModel.company.imageId)) {
                this.logoId = this.storyResponseModel.company.imageId;
                this.toggleCompanyLogo();
            }
        }

        if (this.storyResponseModel.contacts != null && this.storyResponseModel.contacts.length > 0) {
            this.contactsDataSource.dataSource = this.storyResponseModel.contacts;
            this.toggleContact();
        }

        if (this.storyResponseModel.links != null && this.storyResponseModel.links.length > 0) {
            this.linksDataSource.dataSource = this.storyResponseModel.links;
            this.toggleLink();
        }

        if (this.storyResponseModel.subjects != null && this.storyResponseModel.subjects.length > 0) {
            this.selectedSubject = [];
            for (const subject of this.storyResponseModel.subjects) {
                this.selectedSubject.push(subject.id);
            }
        }

        if (this.storyResponseModel.bodyContents != null && this.storyResponseModel.bodyContents.length > 0) {
            this.bodyContents = this.storyResponseModel.bodyContents;
            this.updateRemainingBodyContents();
        }

        this.statusId = this.storyResponseModel.statusId;
        this.isRetracted = false;
        if (this.statusId === this.statusEnum.RETRACTED ||
            this.statusId === this.statusEnum.MODERATED) {
            this.showLogoButton = true;
            this.aboutUsButton = true;
            this.linkButton = true;
            this.contactButton = true;
            this.subjectDropDownDisabled = true;
            this.isRetracted = true;
        } else {
            this.subjectDropDownDisabled = false;
        }

        this.reservedUrl = this.getReservedUrl();
    }

    public getReservedUrl(): string {
        let url: string = this.externalWebsiteURL;

        if (this.storyResponseModel.storySlug) {
            // Remove bad characters . ! , . ` ' " from the URL, they can cause problems and the backend doesn't care about them in terms of routing
            url += '/' + this.storyResponseModel.storySlug.replace(/[\.\!,\/`'"]/g, '');
        }

        return url;
    }

    public resetStoryViewData(): void {
        this.id = 0;
        this.name.setValue('');
        this.headline.setValue('');
        this.body.setValue('');
        this.author = '';
        this.aboutUs.setValue('');
        this.statusId = 0;
        this.logoId = null;
        this.logoUrl = null;
        this.datelineDate = undefined;
        this.datelineLocation.setValue('');

        this.showPublishLater = false;
        this.companyName.setValue('');
        this.contactsDataSource.dataSource = [new ContactsItemModel()];
        this.linksDataSource.dataSource = [];
        this.selectedSubject = [];
        this.showLogoPlaceholder = false;
        this.aboutUsButtonDisabled = false;
        this.contactButtonDisabled = false;
        this.linkButtonDisabled = false;
        this.showLogoButton = false;
        this.aboutUsButton = false;
        this.linkButton = false;
        this.contactButton = false;
        this.linkButtons = storyLinksButton;
        this.contactButtons = storyContactsButton;
        this.storyResponseModel =  new UnifiedStoryResponseModel();
        this.reservedUrl = '';
        this.publishDate = null;
        this.isRetracted = false;
        this.subjectDropDownDisabled = false;
        this.companyId = null;
        this.deliverySchedulingType = deliverySchedulingTypesEnum.immediate;
        this.publishedTimeStamp = 0;
        this.bodyContents = [];
    }

    public resetPublishData(): void {
        const now: Date = new Date();

        this.publishDate = now;
        this.showPublishLater = false;
        this.deliverySchedulingType = deliverySchedulingTypesEnum.immediate;
        this.publishTime = new TimeModel();
        this.publishTime.timeZone = 'UTC';

        if (this.preferences && this.preferences.timeZone) {
            this.publishTime.timeZone = this.preferences.timeZone;
        }
    }

    public showMessage(headMessage: string, detailmessage: string, messageSeverity: string) {
        this.messageService.add({severity: messageSeverity, summary: headMessage, detail: detailmessage});
    }

    public onCancel(): void {
        this.showDialog = false;
    }

    public getIconsDeleteStatus(event): void {
        this.showLogoButton =  false;
        this.logoId = null;
    }

    public handleError(error): void {
        if (!error.status || error.status === 500) {
            this.showMessage(storyConstants.errorHeading, storyConstants.serverErrorMessage, 'error');
        } else if (error.status === 461) {
            this.showMessage(storyConstants.errorHeading, storyConstants.imageErrorMessage, 'error');
        } else {
            this.showMessage(storyConstants.errorHeading, error.statusText, 'error');
        }
    }

    /**
     *
     * Returns a boolean representation of whether the publishDate is set or not
     */
    public hasPublishDate(): boolean {
        const hasValue: boolean = this.publishDate !== null && this.publishDate !== undefined;
        const isDate: boolean = this.publishDate instanceof Date;
        let hasPublishDate: boolean = false;

        if (hasValue && isDate) {
            hasPublishDate = true;
        }

        return hasPublishDate;
    }

    /**
     *
     * Sets the status to a provided value
     */
    private setStatus(status: StatusEnum): void {
        this.statusModel.id = status;
    }

    /**
     *
     * returns the publishDate formatted as a time stamp
     */
    private getPublishTimestamp(): number {
        const hasPublishDate: boolean = this.hasPublishDate();
        let timestamp: number = null;

        if (hasPublishDate) {
            timestamp = this.getTimestamp(this.publishDate);
        }

        return timestamp;
    }

    /**
     *
     * Returns the provided date formatted a a time stamp
     */
    private getTimestamp(date: Date): number {
        let momentDate = moment(date);
        if (this.publishTime && this.publishTime.timeZone) {
            momentDate = momentDate.tz(this.publishTime.timeZone);
        }

        const timestamp: number = momentDate.utc().unix() * 1000;
        return timestamp;
    }

    public getFormattedTime(date: Date, timezone: string): string {
        let momentDate = moment(date);
        if (timezone) {
            momentDate = momentDate.tz(timezone);
        } else {
            momentDate = momentDate.tz('UTC');
        }
        return momentDate.format(this.preferences.getDateFormatString(true, true, true));
    }

    private getPreferences(): void {
        this.currentUserStateService.getPreferences().pipe(filter(x => !!x))
            .subscribe({
                next: (preferences) => {
                    this.preferences = preferences;
                    this.dateFormat = this.preferences.getDateFormatString(true);
                },
                error: (error) => this.handleError(error)
            });
    }

    /*
    * Set publish date and time with timezone
    */
    private setPublishDateAndTime() {
        const timezone: string = this.storyResponseModel.timeZone;
        const publishDate: Date = new Date(this.storyResponseModel.publishedDate);
        this.publishedTimeStamp = this.storyResponseModel.publishedDate;
        this.dateText = storyConstants.publishedDateText;
        let lastModifiedDate: Date = publishDate;
        const minutes = (this.storyResponseModel.modifiedDate - this.storyResponseModel.publishedDate) / storyConstants.convertIntoMinute;

        if (
            this.storyResponseModel.modifiedDate !== null
            && this.storyResponseModel.modifiedDate > 0
            && minutes >= storyConstants.minuteCompareLimit
        ) {
            this.dateText = storyConstants.updatedDateText;
            lastModifiedDate = new Date(this.storyResponseModel.modifiedDate);
        }

        if (timezone) {
            this.publishTime = this.timeHelper.getTimeFromDate(publishDate, timezone, timeFormatsEnum.twelveHour);
            this.storyModifiedDate = this.getFormattedTime(lastModifiedDate, timezone);
        } else if (this.preferences && this.preferences.timeZone) {
            this.publishTime = this.timeHelper.getTimeFromDate(publishDate, this.preferences.timeZone, timeFormatsEnum.twelveHour);
            this.storyModifiedDate = this.getFormattedTime(lastModifiedDate, this.preferences.timeZone);
        } else {
            this.currentUserStateService
                .getPreferences().pipe(filter(x => !!x))
                .subscribe(
                    preferences => {
                        this.preferences = preferences;
                        this.publishTime = this.timeHelper.getTimeFromDate(publishDate, this.preferences.timeZone, timeFormatsEnum.twelveHour);
                        this.storyModifiedDate = this.getFormattedTime(lastModifiedDate, this.preferences.timeZone);
                    }
                );
        }

        if (this.storyResponseModel.statusId !== this.statusEnum.PUBLISHED) {
            this.deliverySchedulingType = deliverySchedulingTypesEnum.future;
            this.publishDate = publishDate;
        }
    }

}
